import { MappingItem } from '../../GTM'
import { cartItemMapping } from './cartItemMapping'
import { Cart, CartTaxItem, Discount, Maybe } from '@pylot-data/pylotschema'
import { deepValue } from '@corratech/pylot-utils'

const sumTotalAmounts = (
    items?: Maybe<Array<Maybe<Discount>>> | Maybe<Array<Maybe<CartTaxItem>>>
): number => {
    if (!Array.isArray(items)) {
        return 0
    }
    let total = 0
    items.forEach((item: Maybe<Discount | CartTaxItem>) => {
        total += Number(item?.amount?.value)
    })
    return total
}

const getTotalDiscount = (data: Cart): number => {
    return sumTotalAmounts(data?.prices?.discounts)
}

const getTotalTax = (data: Cart): number => {
    return sumTotalAmounts(data?.prices?.applied_taxes)
}

const getShippingCost = (data: Cart): number => {
    const methods = deepValue(data, ['shipping_addresses'])
    if (!Array.isArray(methods)) {
        return 0
    }
    for (const method of methods) {
        const shippingCost = deepValue(method, [
            'selected_shipping_method',
            'amount',
            'value'
        ])
        if (typeof shippingCost !== 'undefined') {
            return shippingCost
        }
    }
    return 0
}

const getAppliedCouponList = (data: Cart): string => {
    if (!Array.isArray(data?.applied_coupons)) {
        return ''
    }
    const couponList: string[] = []
    for (const coupon of data.applied_coupons) {
        if (coupon?.code) {
            couponList.push(coupon.code)
        }
    }
    return couponList.join(',')
}

export const orderData = (itemMapping = cartItemMapping()): MappingItem => {
    return {
        actionField: {
            revenue: ['prices', 'grand_total', 'value'],
            coupon: getAppliedCouponList,
            tax: getTotalTax,
            shipping: getShippingCost,
            discount: getTotalDiscount
        },
        productsDetails: {
            data_source: ['cart', 'items'],
            mapping: itemMapping,
            strict: true
        }
    }
}
